import { unicodeCaseFold } from "./unicodeCaseFold";
import { isVariableIdToken, scanVariableTokens } from "./variableTokens";

interface PatternVariable {
  id: string;
  key: string;
}

// Unique names are an editing projection only. Stored IDs stay authoritative,
// including when two declarations have the same name in different scopes.
export function variablePatternAliases(variables: readonly PatternVariable[]) {
  const names = new Map<string, PatternVariable[]>();
  for (const variable of variables) {
    const name = unicodeCaseFold(variable.key);
    names.set(name, [...(names.get(name) ?? []), variable]);
  }
  const display = new Map<string, string>();
  const stored = new Map<string, string>();
  for (const group of names.values()) {
    if (group.length !== 1) continue;
    const variable = group[0];
    if (
      !variable ||
      isVariableIdToken(variable.key) ||
      scanVariableTokens(`{${variable.key}}`)[0] !== variable.key
    )
      continue;
    display.set(variable.id, variable.key);
    stored.set(unicodeCaseFold(variable.key), variable.id);
  }
  return { display, stored };
}

export function rewritePatternTokens(
  value: string,
  aliases: ReadonlyMap<string, string>,
  foldNames = false,
) {
  return value.replace(
    /\{([A-Za-z0-9_][A-Za-z0-9_-]*)\}/g,
    (match: string, token: string) => {
      const replacement = aliases.get(
        foldNames ? unicodeCaseFold(token) : token,
      );
      return replacement === undefined ? match : `{${replacement}}`;
    },
  );
}
